import { NavLink } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib_api';
import {
  LayoutDashboard,
  CalendarRange,
  BrainCircuit,
  Activity,
  Users,
  CreditCard,
  Wallet,
  ScrollText,
  Settings,
  Bot,
  ShieldCheck,
  FileSearch,
  BellRing,
  CandlestickChart,
  Copy,
  Mail,
} from 'lucide-react';

const items = [
  { to: '/', label: 'Overview', icon: LayoutDashboard },
  { to: '/macro-calendar', label: 'Macro Calendar', icon: CalendarRange },
  { to: '/strategy-ops', label: 'Strategy Ops', icon: BrainCircuit },
  { to: '/runtime-monitor', label: 'Trading Health', icon: Activity },
  { to: '/users', label: 'Users', icon: Users },
  { to: '/subscriptions', label: 'Subscriptions', icon: CreditCard },
  { to: '/trading-accounts', label: 'Trading Accounts', icon: Wallet },
  { to: '/audit-logs', label: 'Audit Logs', icon: ScrollText },
  { to: '/settings', label: 'Settings', icon: Settings },
  { to: '/ai-usage', label: 'AI Usage', icon: Bot },
  { to: '/ai-policies', label: 'AI Policies', icon: ShieldCheck },
  { to: '/ai-events', label: 'AI Events', icon: FileSearch },
  { to: '/mt5-activations', label: 'MT5 Activations', icon: BellRing },
  { to: '/admin-signals', label: 'Admin Signals', icon: CandlestickChart },
  { to: '/copy-trading', label: 'Copy Trading', icon: Copy },
  { to: '/email-campaigns', label: 'Email Campaigns', icon: Mail },
];

type SidebarProps = {
  onClose?: () => void;
};

export default function Sidebar({ onClose }: SidebarProps) {
  const pending = useQuery({
    queryKey: ['admin', 'mt5-activations-pending-count'],
    queryFn: async () => (await api.get('/api/admin/mt5/autotrading-requests?status=pending')).data,
    refetchInterval: 20000,
  });
  const pendingCount = Number(pending.data?.pendingCount || 0);

  return (
    <aside className="h-full w-72 shrink-0 border-r border-gray-200 bg-white dark:border-darkCard dark:bg-[#111f2b]">
      <div className="border-b border-gray-200 p-5 dark:border-darkCard">
        <p className="text-xs uppercase tracking-wider text-mutedGray dark:text-darkTextSecondary">Internal</p>
        <h2 className="text-lg font-semibold text-darkText dark:text-darkTextPrimary">Pickaxe Admin</h2>
      </div>
      <nav className="space-y-2 overflow-y-auto p-4">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition ${
                  isActive
                    ? 'bg-indigo-50 text-indigo-700 dark:bg-indigo-600/30 dark:text-white'
                    : 'text-mutedGray hover:bg-gray-100 hover:text-darkText dark:text-darkTextSecondary dark:hover:bg-white/10 dark:hover:text-white'
                }`
              }
              onClick={onClose}
            >
              <Icon className="h-4 w-4" />
              {item.label}
              {item.to === '/mt5-activations' && pendingCount > 0 ? <span className="ml-auto rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-semibold text-amber-800">{pendingCount}</span> : null}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
